import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, distinctUntilChanged, ReplaySubject, takeUntil } from 'rxjs';

import { ApiService } from '../../sign-up/services/api.service';
import { BlogsListModel, CategoryModel, PostModel, SelectCategoryModel } from '../../sign-up/models/sign-up.model';
import { LocaleService } from '../../../locale/locale.service';
import { RoutesEnum } from "../../../locale/routes.enum";

@Component({
  selector: 'app-blog-list',
  templateUrl: './blog-list.component.html',
  styleUrls: [
    './styles/blog-list.component.scss',
    './styles/blog-list-desktop.scss',
    './styles/blog-list-tablet.scss',
    './styles/blog-list-mobile.scss',
  ]
})
export class BlogListComponent implements OnInit, OnDestroy {

  readonly destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  public categoryList = [
    {
      id: 0,
      label: 'MAIN.ALL_CATEGORIES',
      icon: '',
    },
  ];

  public basicCategory = [
    {
      id: 0,
      label: 'MAIN.ALL_CATEGORIES',
      icon: '',
    },
  ];

  public category: { [key: number]: CategoryModel } = {};

  public selectedCategory: string = '0';
  public currentCategory?: SelectCategoryModel;

  public postsList$: BehaviorSubject<PostModel[]> = new BehaviorSubject<PostModel[]>([]);
  public displayPagination$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public postCount: number = 0;
  public routesEnum: typeof RoutesEnum = RoutesEnum;

  public selectCategoryControl: FormControl = new FormControl(this.basicCategory[0]);

  constructor(
    public apiService: ApiService,
    public localeService: LocaleService,
  ) {
  }

  ngOnInit() {
    this.localeService.currentLocalePrefix$
      .pipe(
        distinctUntilChanged(),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.getCategoryList();
      });
  }

  public prepareCategoryList(category: { [key: number]: CategoryModel }): void {
    this.categoryList = this.basicCategory;
    for (let key in category) {
      this.categoryList = [
        ...this.categoryList,
        {
          id: +key,
          label: category[key].name,
          icon: category[key].icon
        }
      ];
    }
  }

  public getCategoryList(): void {
    this.apiService.getArticleList()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: BlogsListModel) => {
        if (!data.posts) {
          this.postsList$.next([]);
          return;
        }
        this.postsList$.next(data.posts.map(post => {
          return {
            ...post,
            createdDate: post.created_at * 1000, // convert to utc format (10 characters in response)
          };
        }));

        this.prepareCategoryList(data.category);
        this.category = data.category;
        this.displayPagination$.next(data.posts.length > 6);
        this.postCount = data.posts.length;
      })
  }

  public selectCategory(categoryId: number): void {
    if (+categoryId === 0) {
      this.getCategoryList();
      return;
    }

    this.apiService.getArticleListByCategory(categoryId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        if (!data.posts) { return; }
        this.postsList$.next(data.posts.map(post => {
          return {
            ...post,
            createdDate: post.created_at * 1000, // convert to utc format (10 characters in response)
          };
        }));
      });
  }

  public getCategoryBadge(categoryKey: string, categoryId: number): string {
    const category: any = this.category[categoryId];
    return category[categoryKey];
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}
